import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import { sendProblemMail, reset } from "../../../reducers/problemReducer";

import { documentTypeEnum } from "../../../shared/selectors/documentTypeEnum";
import { to_ISelect_Enum } from "../../../shared/mutator/dataTransformSelect";
import {
  initialValuesProblem as initialValues,
  IProblem,
} from "../../../shared/model/problem.model";
import { IRootState } from "../../../reducers";
import { useFormikProblem } from "./useFormikProblem";
import { RouteComponentProps } from "react-router-dom";
import { ErrorMessage, FormikProvider } from "formik";
import { HaveProblemButtons } from "./HaveProblemButtons";
import { problemTypeEnum } from "../../../shared/selectors/problemTypeEnum";
import {
  placeholderSelectSimple,
  placeholderText,
} from "../../../shared/helpers/placeHolders";
import { customStyles } from "../form/custom-selector-styles";
import { SpinnerKonecta } from "../../../shared/layout/spinner/Spinner";
import { ModalResponse } from "../../../shared/dialog/modal-response";
import { IMessage } from "../../../shared/model/message.model";
import { ModalError } from "../../../shared/dialog/modal-error";
const animatedComponents = makeAnimated();

interface IHaveProblemFormComponent
  extends StateProps,
    DispatchProps,
    RouteComponentProps<{ id: string }> {}

export const HaveProblemForm = (props: IHaveProblemFormComponent) => {
  const messageSuccess: IMessage = {
    title: "Se envió su reclamo correctamente",
    body: "Hemos recibido tu email y nos pondremos en contacto lo antes posible con una solución",
    footer: "",
  };
  const [showModalConfirm, setShowModalConfirm] = useState(false);

  const handleClose = () => {
    props.reset();
    props.history.goBack();
  };
  const saveConfirm = () => {
    formik.handleSubmit();
  };

  const saveEntityConfirm = (entity: IProblem) => {
    props.sendProblemMail(entity);
  };

  const { formik } = useFormikProblem({
    initialValues,
    saveEntityConfirm,
  });

  return (
    <div>
      <div className="container-general-postulate">
        <div className="step-form mt-5">
          <Row>
            <Col className="text-center container-postulate-header">
              <div className="title-postulate">
                Contanos tu problema, y nos pondremos en contacto
              </div>
            </Col>
          </Row>
          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              onSubmit={formik.handleSubmit}
              className="container-form-postulate mt-5"
            >
              <Label className="title-form">Datos personales</Label>
              <Row className="container-inputs-form">
                <Col>
                  <FormGroup>
                    <Label
                      id="countryLabel"
                      for="person.country"
                      className={
                        formik.touched?.firstName
                          ? formik.errors?.firstName
                            ? "text-danger"
                            : ""
                          : ""
                      }
                    >
                      Nombre*
                    </Label>
                    <Input
                      name="name"
                      onChange={formik.handleChange("firstName")}
                      onBlur={formik.handleBlur("firstName")}
                      value={formik.values.firstName}
                      className={`form-control ${
                        formik.touched?.firstName &&
                        formik.errors?.firstName &&
                        "is-invalid"
                      }`}
                      placeholder={placeholderText()}
                    />
                    <div className="invalid-feedback">
                      <ErrorMessage name="firstName" />
                    </div>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label
                      id="countryLabel"
                      for="person.country"
                      className={
                        formik.touched?.lastName
                          ? formik.errors?.lastName
                            ? "text-danger"
                            : ""
                          : ""
                      }
                    >
                      Apellido*
                    </Label>
                    <Input
                      onChange={formik.handleChange("lastName")}
                      onBlur={formik.handleBlur("lastName")}
                      value={formik.values.lastName}
                      className={`form-control ${
                        formik.touched?.lastName &&
                        formik.errors?.lastName &&
                        "is-invalid"
                      }`}
                      placeholder={placeholderText()}
                    />
                    <div className="invalid-feedback">
                      <ErrorMessage name="lastName" />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              {/* persona data 2 - DNI, EMAIL*/}
              <Row className="container-inputs-form mt-5">
                <Col>
                  <FormGroup>
                    <Label
                      id="documentTypeLabel"
                      for="person.documentType"
                      className={
                        formik.touched?.document && formik.errors?.document
                          ? "text-danger"
                          : ""
                      }
                    >
                      Tipo y nro documento*
                    </Label>
                    <Row className="input-document-group">
                      <Col md="4" xs="4">
                        <Select
                          options={documentTypeEnum()}
                          components={animatedComponents}
                          value={to_ISelect_Enum(
                            formik.values.documentType,
                            documentTypeEnum()
                          )}
                          onChange={(e: any) => {
                            formik.setFieldValue("documentType", e.value);
                          }}
                          styles={customStyles}
                          className="select-postulate"
                        />
                      </Col>
                      <Col md="8" xs="8">
                        <FormGroup>
                          <Input
                            onChange={formik.handleChange("document")}
                            onBlur={formik.handleBlur("document")}
                            value={formik.values.document}
                            className={`form-control ${
                              formik.touched?.document &&
                              formik.errors?.document &&
                              "is-invalid"
                            }`}
                            placeholder={placeholderText()}
                          />
                          <div className="invalid-feedback">
                            <ErrorMessage name="document" />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label
                      id="documentTypeLabel"
                      for="person.documentType"
                      className={
                        formik.touched?.mail && formik.errors?.mail
                          ? "text-danger"
                          : ""
                      }
                    >
                      Correo*
                    </Label>
                    <Input
                      onChange={formik.handleChange("mail")}
                      onBlur={formik.handleBlur("mail")}
                      value={formik.values.mail}
                      className={`form-control ${
                        formik.touched?.mail &&
                        formik.errors?.mail &&
                        "is-invalid"
                      }`}
                      placeholder={placeholderText()}
                    />
                    <div className="invalid-feedback">
                      <ErrorMessage name="mail" />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              {/* reason */}
              <Row className="container-inputs-form mt-5">
                <Label className="title-form">Motivo del contacto</Label>
                <Select
                  options={problemTypeEnum()}
                  placeholder={placeholderSelectSimple()}
                  components={animatedComponents}
                  value={to_ISelect_Enum(
                    formik.values.reason,
                    problemTypeEnum()
                  )}
                  onChange={(e: any) => {
                    formik.setFieldValue("reason", e.value);
                  }}
                  onBlur={formik.handleBlur("reason")}
                  styles={customStyles}
                  className="select-postulate"
                />
              </Row>
              {/* message */}
              <Row className="container-inputs-form mt-5">
                <Label className="title-form">Mensaje</Label>
                <Input
                  type="textarea"
                  onChange={formik.handleChange("message")}
                  onBlur={formik.handleBlur("message")}
                  value={formik.values.message}
                  className={`form-control ${
                    formik.touched?.message &&
                    formik.errors?.message &&
                    "is-invalid"
                  }`}
                  placeholder={placeholderText()}
                />
                <div className="invalid-feedback">
                  <ErrorMessage name="message" />
                </div>
              </Row>
              <HaveProblemButtons
                formik={formik}
                setShowModalConfirm={setShowModalConfirm}
                handleClose={handleClose}
              />
            </Form>
          </FormikProvider>
        </div>
      </div>

      {showModalConfirm && (
        <>
          <ModalResponse
            loading={props.loading}
            errorMessage={props.errorMessage}
            updateSuccess={props.updateSuccess}
            messageSuccess={messageSuccess}
            handleClose={handleClose}
            setShowModalConfirm={setShowModalConfirm}
            saveConfirm={saveConfirm}
          />
        </>
      )}
      {props.errorMessage && !showModalConfirm && (
        <ModalError error={props.errorMessage} handleClose={handleClose} />
      )}
    </div>
  );
};

const mapStateToProps = (state: IRootState) => {
  return {
    errorMessage: state.problemReducer.errorMessage,
    updating: state.problemReducer.updating,
    updateSuccess: state.problemReducer.updateSuccess,
    loading: state.problemReducer.loading,
    problem: state.problemReducer,
  };
};
const mapDispatchToProps = {
  sendProblemMail,
  reset,
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(HaveProblemForm);
